module.exports = __webpack_public_path__ + "img/3.4e593213.png";